// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"9a4ff51f","129":"70868fd1","194":"313a3ea5","708":"b2a5d7d8"}[chunkId] + ".chunk.js";
};